"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This is the standard Oracle logo in SVG form. You can choose between the
 * colors Red, White, and Black. Red is default.
 *
 * This component will fill the containing ancestor unless additionalClassNames
 * are supplied to set the size of this element. If you need to restrict the
 * size of this logo (which is likely) you should supply a CSS
 * additionalClassNames which sets the desired size, or you may place it in an
 * ancestor which has the desired size.
 **/
var React = require("react");
var classNames = require("classnames");
var OracleLogoColor;
(function (OracleLogoColor) {
    /**
     * Red.
     */
    OracleLogoColor["Red"] = "oui-svg-fill-oracle-red";
    /**
     * White.
     */
    OracleLogoColor["White"] = "oui-svg-fill-oracle-white";
    /**
     * Black.
     */
    OracleLogoColor["Black"] = "oui-svg-fill-oracle-black";
})(OracleLogoColor = exports.OracleLogoColor || (exports.OracleLogoColor = {}));
/**
 * OUI Oracle logo component.
 * Creates an SVG document fragment to display Oracle corporate logo.
 *
 * @oui-component OracleLogo
 */
var OracleLogo = function (_a) {
    var _b = _a.logoColor, logoColor = _b === void 0 ? OracleLogoColor.Red : _b, testId = _a.testId;
    return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "1.659 3.393 65.353 8.196", "aria-labelledby": "oracle-logo-title", className: classNames("oracle-logo", logoColor), "data-test-id": testId },
        React.createElement("title", { id: "oracle-logo-title" }, "Oracle \u00AE"),
        React.createElement("path", { d: "M28.86,8.725h4.164L30.825,5.18l-4.038,6.407l-1.841,0.002l4.916-7.695 c0.435-0.655,1.466-0.662,1.911-0.014l4.932,7.709l-1.841-0.002L34,10.155h-4.219L28.86,8.725L28.86,8.725z M47.964,10.157V3.473 h-1.561v7.337c0,0.203,0.082,0.397,0.227,0.542c0.153,0.151,0.355,0.235,0.572,0.235h7.116l0.917-1.43H47.964L47.964,10.157z M22.149,8.96c3.537,0,3.537-5.487,0-5.487H15.32v8.114h1.559V4.903h5.162c1.694,0,1.694,2.628,0,2.628l-4.397-0.002l4.656,4.058 h2.267l-3.133-2.628L22.149,8.96L22.149,8.96z M5.716,11.587c-2.209,0-4.057-1.846-4.057-4.056c0-2.21,1.847-4.058,4.057-4.058 h4.717c2.21,0,4.057,1.847,4.057,4.058c0,2.211-1.847,4.058-4.057,4.058L5.716,11.587L5.716,11.587z M10.328,10.158 c3.387,0,3.387-5.254,0-5.254L5.821,4.903c-3.388,0-3.388,5.255,0,5.255H10.328L10.328,10.158z M39.961,11.587 c-2.209,0-4.058-1.845-4.058-4.056c0-2.211,1.848-4.058,4.058-4.058h5.605l-0.919,1.431l-4.581-0.001c-3.389,0-3.39,5.255,0,5.255 h5.626l-0.916,1.429H39.961L39.961,11.587z M59.049,10.158c-1.201,0-2.217-0.808-2.527-1.909h6.67l0.919-1.431L56.52,6.817 c0.311-1.104,1.325-1.914,2.529-1.914l4.578,0.001l0.92-1.431h-5.605c-2.209,0-4.058,1.848-4.058,4.058 c0,2.211,1.849,4.056,4.058,4.056h4.815l0.917-1.429H59.049L59.049,10.158z" }),
        React.createElement("path", { d: "M65.382,4.337c0-0.918,1.423-0.918,1.433,0C66.824,5.253,65.382,5.267,65.382,4.337L65.382,4.337 z M66.099,5.252c1.175,0,1.172-1.825,0-1.824C64.93,3.429,64.918,5.252,66.099,5.252L66.099,5.252z M66.013,3.799 c0.141,0,0.199,0.001,0.268,0.027c0.157,0.053,0.223,0.225,0.187,0.371c-0.01,0.038-0.033,0.117-0.127,0.175 c-0.01,0.008-0.016,0.013-0.045,0.024l0.237,0.425h-0.23L66.095,4.43h-0.138v0.391h-0.2V3.799H66.013L66.013,3.799z M66.085,4.261     c0.061-0.001,0.129-0.006,0.17-0.064c0.044-0.08,0.026-0.151-0.054-0.212c-0.046-0.018-0.093-0.018-0.188-0.018h-0.056v0.294 H66.085L66.085,4.261z" })));
};
exports.default = OracleLogo;
//# sourceMappingURL=OracleLogo.js.map